IREP.FeedbackSurvey = (function () {
    var quizData;
    //update this to the real actCode before produciton release
    var actCode = "";
    var currentQuestionIndex = 0;
    var results = [];
    
    var init = function (queryStringActCode, projectId) {
        if (queryStringActCode) {
            actCode = queryStringActCode;
        }
            
        // check if the user has taken the survery
        IREP.callApi({
            url: "/promotion/PopupSurvey/GetSurvey",
            data: {
                ActivityCode: actCode,
                CultureCode: IREP.options.user.cultureCode,
                PaxUID: IREP.options.user.currentUID,
                UseMobileText: false,
                ProjectId: projectId
            }
        }).done(function (data) {
            if (data.optIn && !data.hasTaken ) {
                quizData = data.survey;
                
                $(".points").each(function (index) {
                    var repText = $(this).text();
                    repText = repText.replace("[XX]", "<span class='pointsValue'>" + quizData.points + "</span>");
                    $(this).html(repText);
                });
                //if all else is good, start the timer
                var interval = setInterval(function () {                    
                    if (!$("#storeDisclaimer").is(":visible")) {
                        $("#mobileSurveyContainer").show();
                        $("#startScreen").show();
                        $(".startSurvey").show();
                        clearInterval(interval);
                    }
                }, 10000);               
            } else {
                return;
            }
        });
        
        $(".pageButton").one("click", pageButtonClicked);
        

        $("#answers").on("click", ".answer", function () {            
            $(".answer").removeClass("selected");
            $(this).addClass("selected");
            $("#questionError").hide();
        });

        $(".RML").click(function () {
            IREP.callApi({
                type: 'POST',
                url: "/promotion/PopupSurvey/Postpone",
                data: {
                    ActivityCode: quizData.activityCode
                }
            }).done(function (data) {
                $("#mobileSurveyContainer").hide();
            });
        });

        $(".cancelPopupSurvey, .yesButton").click(function () {
            var currentScreen = $(".slide:visible").attr("id");
            if ( currentScreen == "quitScreen") {
                IREP.callApi({
                    type: 'POST',
                    url: "/promotion/PopupSurvey/OptOut",
                    data: {
                        ActivityCode: quizData.activityCode
                    }
                }).done(function (data) {
                    $("#mobileSurveyContainer").hide();
                });
            } 
            else if (currentScreen == "finalScreen" )
            {
                $("#mobileSurveyContainer").hide();            
            } else {
                $(".slide").hide();
                $("#quitScreen").show();
                $(".pageButtonContent").hide();
                $(".returnToQuiz").show();
                $(".yesButton").show();
            }
        });

    };

    var pageButtonClicked = function () {
        var currentScreen = $(".slide:visible").attr("id");

        if (currentScreen == "startScreen") {
            startQuiz();
        } else if (currentScreen == "quizQuestion") {
            loadNextQuestion();
        } else if (currentScreen == "quitScreen") {
            returnToLastQuestion();
        }        
    };

    var returnToLastQuestion = function () {        
        currentQuestionIndex = results.length;
        $(".yesButton").hide();
        startQuiz();
    }

    var loadNextQuestion = function () {
        if ($(".answer.selected").length == 0) {
            $("#questionError").show();
            $(".pageButton").one("click", pageButtonClicked);
        } else {
            $("#questionError").hide();
            results.push({
                questionid: $("#question").attr("data-questionid"),
                answerid: $(".answer.selected").attr("data-answerid"),
                correct: true,
                text: $(".answer.selected").text()
            });
            if (quizData.questions.length > currentQuestionIndex) {
                nextQuestion();
                $(".pageButton").one("click", pageButtonClicked);
            } else {
                // push results
                IREP.callApi({
                    type: 'POST',
                    url: "/promotion/PopupSurvey/Submit",
                    data: {
                        ActivityCode: quizData.activityCode,
                        ActivityUID: quizData.activityUID,
                        Results: results
                    }
                }).done(function (data) {
                    if (!data.pass) {
                        // if they didn't pass they must be cheating, shut them down
                        $("#mobileSurveyContainer").empty().hide();
                    }
                    $("#finalScreen").show();
                    $("#quizQuestion").hide();
                    $(".lowerContent").hide();
                    $(".pageButton").one("click", pageButtonClicked);
                });
            }
        }
    };
    var startQuiz = function () {
        $(".slide").hide();
        $(".pageButtonContent").hide();
        $(".nextArrow").show();
        $("#questionSlider").empty();
        $.each(quizData.questions, function (index, value) {            
            $("#questionSlider").append("<div class='questionCircle' data-index='" + index + "' ></div>");
        });
        loadQuestion(currentQuestionIndex, quizData.questions[currentQuestionIndex++]);
        $("#quizQuestion").attr("data-question-id", "").show();
        $(".RML").hide();
        $(".pageButton").one("click", pageButtonClicked);
    }

    var nextQuestion = function () {
        loadQuestion(currentQuestionIndex, quizData.questions[currentQuestionIndex++]);
    }

    var loadQuestion = function (index, question) {
        $("#questionText").text(question.questionText);
        $("#question").attr("data-questionid", question.questionId);
        $("#answers").empty();
        $(".questionCircle").removeClass("selected");
        $.each(question.answers, function (index, value) {
            $("#answers").append("<div class='answer' data-answerid='" + value.answerId + "'>" + value.answerText + "</div>");
        });
        $(".questionCircle[data-index=" + index + "]").addClass("selected");
    }

    return {
        init: init
    };
})();


IREP.FeedbackSurveyEditor = (function () {
    
    var init = function () {
        
        $(".surveyDataRow > div").on("click", function () {
        
            var whatWasClicked = $(this);

            if (whatWasClicked.attr("data-deleteSurveyId")) {
                if (confirm("Are you sure you want to delete this?")) {
                    IREP.callApi({
                        type: 'POST',
                        url: "promotion/PopupSurvey/Delete",
                        data: {
                            Id: whatWasClicked.attr("data-deleteSurveyId")
                            }
                    }).done(function (data) {
                        window.location = window.location;
                    });
                }
            } else {
                $("#editSurveyWrapper").slideUp(200);
                IREP.callApi({
                    type: 'GET',
                    url: "promotion/PopupSurvey/GetSurveyForEdit",
                    data: {
                        Id: whatWasClicked.parent().attr("data-surveyId")
                    }
                }).done(function (data) {
                    var sd = moment(data.survey.startDate);
                    var ed = moment(data.survey.endDate);
                    $("#surveyProject").show();
                    $("#surveyProjectLabel").html(data.survey.projectId == 0 ? "Production" : data.survey.projectName);
                    $("#surveyProject").val(data.survey.projectId);
                    if ($("#currentProject").val() == data.survey.projectId) {
                        $("#currentProjectWrapper").hide();
                    } else {
                        $("#currentProjectWrapper").show();
                    }

                    $("#txtActivityCode").val(data.survey.activityCode);                    
                    $('#startDate').datepicker("setDate", new Date(sd.format("MM-DD-YY")));
                    $('#endDate').datepicker("setDate", new Date(ed.format("MM-DD-YY")));
                    if (data.survey.active) {
                        $("#chkActive").prop('checked', true);
                    } else {
                        $("#chkActive").removeAttr("checked");
                    }
                    $("#btnSave").attr("data-SurveyId", whatWasClicked.parent().attr("data-surveyId"));
                    $("#btnSave").attr("data-RuleId", data.survey.ruleId);

                    var url = IREP.generateSiteLink("/editor/rule/" + data.survey.ruleId);                   
                    $(".rulesEdit").load(url);    

                    $("#editSurveyWrapper").slideDown(500);
                });
            }
        });
        
        $("#startDate").datepicker({ dateFormat: 'mm-dd-yy' });
        $("#endDate").datepicker({ dateFormat: 'mm-dd-yy' });
        
        $("#btnSave").click(function () {
            var result = IREPEditor.RuleEditor.getRule();
            if ($("#btnSave").attr("data-RuleId")) {
                result.Id = $("#btnSave").attr("data-RuleId");
            } else {
                result.Id = 0;
            }
            result.RuleTypeId = 3;
            result.Name = "FeedbackSurveyRule";
            result.Description = "Content";
            result.Active = 1;

            IREP.callApi("cms/rule",
                "POST",
                {
                    Rule: result
                }).done(function (ruledata) {
                    IREP.callApi({
                        type: 'POST',
                        url: "promotion/PopupSurvey/Update",
                        data: {
                            ActivityCode: $("#txtActivityCode").val(),
                            StartDate: $('#startDate').val(),
                            EndDate: $('#endDate').val(),
                            ProjectId: $("input:radio[name='projectId']:checked").val(),
                            RuleId: (ruledata.rule) ? ruledata.rule.id : 0,
                            Active: $("#chkActive").prop('checked'),
                            Id: $("#btnSave").attr("data-SurveyId")
                        }
                    }).done(function (data) {
                        window.location = window.location;
                    });
                });
        });

        $("#btnCancel").click(function () {
            $("#surveyProjectLabel").html("");
            $("#surveyProject").val("");
            $("#txtActivityCode").val("");
            $('#startDate').datepicker("setDate", new Date());
            $('#endDate').datepicker("setDate", new Date());
            
            $("#chkActive").removeAttr("checked");
            $("#surveyProject").show();
            $("#editSurveyWrapper").slideUp(200);
        });

        $("#btnAddNew").click(function () {
            $("#editSurveyWrapper").slideUp(200);
            $("#btnSave").attr("data-SurveyId", 0);
            if ($("#currentProject").val() == 0) {
                $("#currentProjectWrapper").hide();
            } else {
                $("#currentProjectWrapper").show();
            }
            $("#surveyProjectLabel").html("Production");
            $("#surveyProject").val("");
            $("#txtActivityCode").val("");
            $('#startDate').datepicker("setDate", new Date());
            $('#endDate').datepicker("setDate", new Date());
            var url = IREP.generateSiteLink("/editor/rule/");
            $(".rulesEdit").load(url);
            $("#chkActive").removeAttr("checked");
            $("#editSurveyWrapper").slideDown(500);
        });
    };

    return {
        init: init
    };
})();